import type { ComponentPropsWithoutRef, ElementType } from 'react'

import styles from '@runtime/components/ui/Text.module.scss'

type TextVariant = 'legend' | 'subtle' | 'small'

type TextProps<E extends ElementType> = {
  as?: E
  variant?: TextVariant | TextVariant[]
} & ComponentPropsWithoutRef<E>

export function Text<E extends ElementType = 'div'>({
  as,
  variant,
  className,
  ...props
}: TextProps<E>) {
  const Component = (as || 'div') as ElementType
  const variants = Array.isArray(variant) ? variant : variant ? [variant] : []
  const classes = [
    ...variants,
    ...variants.map((v) => styles[v]),
    className || '',
  ]
    .filter(Boolean)
    .join(' ')
  return <Component className={classes} {...props} />
}
